import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSoundFx: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="sound-fx, sound-effects"><path d="M6 7.75H1.75V16.25H6L12.25 19.75V4.25L6 7.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M19.5 5L20.5804 7.91964L23.5 9L20.5804 10.0804L19.5 13L18.4196 10.0804L15.5 9L18.4196 7.91964L19.5 5Z" fill="currentColor"/><path d="M17.5 13L18.3103 15.1897L20.5 16L18.3103 16.8103L17.5 19L16.6897 16.8103L14.5 16L16.6897 15.1897L17.5 13Z" fill="currentColor"/></CentralIconBase>;
};

export default IconSoundFx;
